document.addEventListener('DOMContentLoaded', () => {
  const stickyCtas = document.querySelector('#model-hub-sticky-ctas') || false
  const footer = document.querySelector('.footer')
  const reviewIntro = document.querySelector('.model-hub__main-body-intro--sticky-ctas-hidden')
  const introContainer = document.querySelector('.model-hub__body-main--sticky-ctas-hidden')
  const elementsToObserve = [footer, reviewIntro, introContainer]

  let hiddenPageSectionInView

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach(entry => {
      hiddenPageSectionInView = entry.isIntersecting

      if (stickyCtas) {
        if (!hiddenPageSectionInView) {
          stickyCtas.classList.add('is-sticky-move-in')
          stickyCtas.classList.remove('is-sticky-move-out')
        } else {
          stickyCtas.classList.remove('is-sticky-move-in')
          stickyCtas.classList.add('is-sticky-move-out')
        }
      }
    })
  })

  elementsToObserve.forEach(element => {
    if (element === null) { return }

    observer.observe(element)
  })
})
